
<info width="700px">
	<div style="text-align: left;">
		<ul>
			<li>
				<span style="font-weight: bold;">View</span> shares let receiving users view the shared network&apos;s configuration and data, but not modify it.
			</li>
			<li>
				<span style="font-weight: bold;">Edit</span> shares let receiving users both view and modify the shared network&apos;s configuration and data.
			</li>
		</ul>
	</div>
</info>

